var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import tinycolor from "tinycolor2";
import validator from "validator";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import id from "@irati/utils/id";
import { ValidationButton } from "@irati/ui/src/FormItem";
import Form from "@irati/ui/src/Form";
import { H1, Body } from "@irati/ui/src/Typography";
import { perkbox } from "@irati/ui/src/global/colors";
import Validation from "@irati/utils/validation";
import Button from "@irati/ui/src/Button";
import adminTracking from "@irati-tracking/admin";
import ColorPicker from "@irati/ui/src/ColorPicker";
import Flex from "@irati/ui/src/Flex";
import Input from "@irati/ui/src/FormItem/Input";
import ColorPreview from "./styled/ColorPreview";
import CustomColorPreview from "./styled/CustomColorPreview";
var PickColorStep = /** @class */ (function (_super) {
    __extends(PickColorStep, _super);
    function PickColorStep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedColor: null,
            selectedId: null,
            customInput: false,
            customColorInput: ""
        };
        _this.updateCustomColor = function (value) {
            _this.setState({ customColorInput: value || "" });
        };
        _this.getCustomColorSelectedHandler = function () {
            _this.setState(function (state) { return ({
                selectedColor: null,
                selectedId: null,
                customInput: !state.customInput
            }); });
        };
        _this.getColorSelectedHandler = function (color, colorItemId) {
            _this.setState(function (state) { return ({
                customInput: false,
                selectedId: colorItemId === state.selectedId ? null : colorItemId,
                selectedColor: colorItemId === state.selectedId ? null : color
            }); });
        };
        _this.onSelectedColorSubmit = function () {
            var _a = _this.state, selectedColor = _a.selectedColor, customInput = _a.customInput, customColorInput = _a.customColorInput;
            var onColorSelected = _this.props.onColorSelected;
            if (customInput) {
                var userColor = customColorInput;
                if (!(userColor[0] === "#")) {
                    userColor = "#" + userColor;
                }
                if (validator.isHexColor(userColor)) {
                    onColorSelected(userColor);
                }
            }
            else {
                onColorSelected(selectedColor);
            }
            adminTracking.updateColorScheme();
        };
        _this.handleCustomPicker = function (color) {
            _this.setState({ selectedColor: color.hex });
            _this.updateCustomColor(color.hex);
        };
        return _this;
    }
    PickColorStep.prototype.render = function () {
        var _this = this;
        var idNamespace = id("pick-color-step", this.props);
        var _a = this.state, selectedColor = _a.selectedColor, selectedId = _a.selectedId, customInput = _a.customInput, customColorInput = _a.customColorInput;
        var _b = this.props, formatMessage = _b.formatMessage, colorsList = _b.colorsList, showSkip = _b.showSkip, onSkip = _b.onSkip;
        return (React.createElement("div", { id: idNamespace, className: "pick-colors" },
            React.createElement(H1, { marginBottom: 4, id: id("title", idNamespace) },
                React.createElement(FormattedMessage, { id: "admin.components.pickColorStep.title" })),
            React.createElement(Body, { id: id("sub-title", idNamespace) },
                React.createElement(FormattedMessage, { id: "admin.components.pickColorStep.subTitle" })),
            React.createElement(Flex, { marginTop: 4, wrap: "wrap" },
                colorsList &&
                    colorsList.map(function (c, i) {
                        var bgCol = "rgb(" + c[0] + ", " + c[1] + ", " + c[2] + ")";
                        var colorString = tinycolor(bgCol).toHexString();
                        var isLight = tinycolor(bgCol).isLight();
                        var itemId = "col-" + i;
                        return (React.createElement(ColorPreview, { id: id("btn-color--" + i, idNamespace), key: itemId, onClick: function () { return _this.getColorSelectedHandler(colorString, itemId); }, isLight: isLight, backgroundColor: bgCol, color: colorString, selectedId: selectedId, itemId: itemId, hexCode: colorString }));
                    }),
                React.createElement(CustomColorPreview, { id: id("btn-color--custom", idNamespace), isValidHex: validator.isHexColor(customColorInput), selected: customInput, isAnySelected: selectedId, color: customColorInput[0] === "#" ? customColorInput : "#" + customColorInput, key: "c-x", onClick: this.getCustomColorSelectedHandler }, customInput && validator.isHexColor(customColorInput) ? ("\u00a0") : (React.createElement(FormattedMessage, { id: "admin.components.pickColorStep.customColorPreviewCircle.custom" })))),
            React.createElement(Form, { id: id("form", idNamespace) },
                customInput && (React.createElement(Flex, { margin: "0 auto", alignContent: "center", direction: "column", alignItems: "center", justifyContent: "center", maxWidth: "420px" },
                    React.createElement(Input, { id: id("field-hex", idNamespace), name: "customColor", label: "", placeholder: perkbox.blue, onChange: this.updateCustomColor, value: customColorInput, validation: Validation.string(formatMessage({ id: "admin.components.pickColorStep.input.validation.required" })).test("is-valid-hex-colour", formatMessage({ id: "admin.components.pickColorStep.input.validation.hexColour" }), function () { return validator.isHexColor(customColorInput); }) }),
                    React.createElement(ColorPicker, { color: selectedColor || "#FFFFFF", onChangeComplete: this.handleCustomPicker }))),
                React.createElement("br", null),
                selectedColor || customInput ? (React.createElement(ValidationButton, { id: id("btn-submit", idNamespace), primary: true, onClick: this.onSelectedColorSubmit },
                    React.createElement(FormattedMessage, { id: "admin.components.pickColorStep.validationButton.setColour" }))) : (showSkip && (React.createElement(Button, { id: id("btn-skip", idNamespace), onClick: onSkip },
                    React.createElement(FormattedMessage, { id: "admin.components.pickColorStep.button.skip" })))))));
    };
    return PickColorStep;
}(Component));
export default injectIntl(PickColorStep);
